import { combineReducers } from 'redux';

import appContext from '../features/appContext';

const rootReducer = combineReducers({
	[appContext.constants.APP_CONTEXT_REDUCER_NAME]: appContext.reducer,
});

export default rootReducer;
